'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPageInit$$anon$1() {
}
export { $c_Lapp_pages_AppPageInit$$anon$1 as $c_Lapp_pages_AppPageInit$$anon$1 };
$c_Lapp_pages_AppPageInit$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPageInit$$anon$1.prototype.constructor = $c_Lapp_pages_AppPageInit$$anon$1;
/** @constructor */
function $h_Lapp_pages_AppPageInit$$anon$1() {
}
export { $h_Lapp_pages_AppPageInit$$anon$1 as $h_Lapp_pages_AppPageInit$$anon$1 };
$h_Lapp_pages_AppPageInit$$anon$1.prototype = $c_Lapp_pages_AppPageInit$$anon$1.prototype;
var $d_Lapp_pages_AppPageInit$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPageInit$$anon$1, "app.pages.AppPageInit$$anon$1", ({
  Lapp_pages_AppPageInit$$anon$1: 1,
  Lframework_components_AppToasts$Icons: 1
}));
export { $d_Lapp_pages_AppPageInit$$anon$1 as $d_Lapp_pages_AppPageInit$$anon$1 };
//# sourceMappingURL=app.pages.-App-Page-Init$$anon$1.js.map
